/**
 * Navigation Store Helper Functions
 * Pure utility functions for navigation state computations
 */

/**
 * Compute tree expanded items from navigation path
 * E.g., path ['Lib', 'Class'] → ['root', 'Lib', 'Lib/Class']
 */
export const computeExpandedFromPath = (path: string[]): string[] => {
  const expanded: string[] = ['root']
  let currentPath = ''

  for (const segment of path) {
    currentPath = currentPath ? `${currentPath}/${segment}` : segment
    expanded.push(currentPath)
  }

  return expanded
}

/**
 * Merge new expanded items with existing, avoiding duplicates
 */
export const mergeExpanded = (existing: string[], newItems: string[]): string[] => {
  const set = new Set(existing)
  newItems.forEach((item) => set.add(item))
  return Array.from(set)
}

/**
 * Join array to string with custom separator
 */
export const joinPath = (path: string[]): string => path.join('/')

/**
 * Join expanded items to string for comparison
 */
export const joinExpandedItems = (items: string[]): string => items.join('|')
